/**
 * Implementación del repositorio de Contract usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { ContractRepository } from '@domain/repositories/contract.repository';
import {
  Contract,
  BudgetMode,
  CreateContractResponse
} from '@domain/models/contract.model';
import {
  BudgetModeDto,
  ContractDto,
  CreateContractResponseDto
} from '@infra/dto/contract.dto';
import {
  BudgetModeMapper,
  ContractMapper,
  CreateContractResponseMapper
} from '@infra/mappers/contract.mapper';

@Injectable({ providedIn: 'root' })
export class ContractRepositoryImpl implements ContractRepository {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/v1/contracts`;

  getBudgetModes(): Observable<BudgetMode[]> {
    return this.http.get<BudgetModeDto[]>(`${this.baseUrl}/budget-modes`).pipe(
      map(dtos => BudgetModeMapper.toDomainList(dtos))
    );
  }

  createContract(formData: FormData): Observable<CreateContractResponse> {
    return this.http.post<CreateContractResponseDto>(this.baseUrl, formData).pipe(
      map(dto => CreateContractResponseMapper.toDomain(dto))
    );
  }

  getContractsByProjectId(projectId: string): Observable<Contract[]> {
    return this.http.get<ContractDto[]>(`${this.baseUrl}?projectId=${projectId}`).pipe(
      map(dtos => dtos.map(dto => ContractMapper.toDomain(dto)))
    );
  }

  getContractById(contractId: string): Observable<Contract> {
    return this.http.get<ContractDto>(`${this.baseUrl}/${contractId}`).pipe(
      map(dto => ContractMapper.toDomain(dto))
    );
  }

  acceptContract(contractId: string, userType?: string): Observable<Contract> {
    const body = userType ? { userType } : {};
    return this.http.patch<ContractDto>(`${this.baseUrl}/${contractId}/accept`, body).pipe(
      map(dto => ContractMapper.toDomain(dto))
    );
  }
}

